import store from '../redux/store';
import { DELIVERY_CHARGE_TYPE } from './constants';

export function isDeliveryPincodeBased() {
  const storeInfo = store.getState().storeReducer.store;
  if (DELIVERY_CHARGE_TYPE.PINCODE_BASED === storeInfo.services?.delivery_charge_type)
    return true;
  return false;
}
